// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2uulQ","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1qNmb"};